/**
 * Stripe's `IntegrationError`s for a Payment Element that is no longer
 * mounted, which is what a form submit hits when its sheet closed mid-submit.
 * Any other `IntegrationError` (a bad client secret, a sheet opened outside a
 * user gesture) is an integration bug.
 */
const UNMOUNTED_ELEMENT_MESSAGES = [
  'the Element you are attempting to use is mounted',
  'should have a mounted Payment Element',
  'Could not find a ready element',
  'Element has already been destroyed',
];

export const isUnmountedElementError = (error: unknown): boolean =>
  error instanceof Error &&
  error.name === 'IntegrationError' &&
  UNMOUNTED_ELEMENT_MESSAGES.some((message) => error.message.includes(message));
